import * as React from "react";
import { Button } from "@/components/ui/button";
import { Plus, PlusCircle } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Standardized "Add" button component using shadcn/ui Button with color-coded icon
 * @param {Function} onClick - Click handler
 * @param {string} variant - Button variant: "default" | "secondary" | "outline" | "contact" (default: "default")
 * @param {string} size - Button size: "default" | "sm" | "lg" | "icon" (default: "default")
 * @param {ReactNode} children - Button content/text
 * @param {string} className - Additional CSS classes
 * @param {boolean} showIcon - Whether to show icon (default: true)
 * @param {object} ...props - Other button props
 */
function AddButton({
  onClick,
  variant = "default",
  size = "default",
  children,
  className = "",
  showIcon = true,
  ...props
}) {
  // Map "contact" variant to "secondary" for backward compatibility
  const buttonVariant = variant === "contact" ? "secondary" : variant;
  
  // Use PlusCircle for default variant (more prominent), Plus for others
  const Icon = variant === "default" ? PlusCircle : Plus;
  
  return (
    <Button
      type="button"
      onClick={onClick}
      variant={buttonVariant}
      size={size}
      className={cn("gap-2", className)}
      {...props}
    >
      {showIcon && <Icon className="h-4 w-4" />}
      {children}
    </Button>
  );
}

export default AddButton;
